import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {CoffeeConfig} from '../classes/CoffeeConfig';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class CoffeeConfigService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<CoffeeConfig[]> {
    return this.httpClient.get<CoffeeConfig[]>(`${environment.backendApiUrl}/v1/coffee-configs`, httpOptions);
  }

  public addOrEdit(coffeeConfig: CoffeeConfig): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/coffee-configs`, coffeeConfig, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/coffee-configs/` + id, httpOptions);
  }
}
